import React, { useState } from 'react';
import Image from 'next/image';
import SectionHeading from '../../Common/SectionHeading';
import Link from 'next/link';

const OvalComponent = ({ title = null }) => {
  const images = [
    {   id: 1, 
        src: 'img/consulting/jpg/ci-tracking/business-consulting.svg', 
        description: {
            heading: 'Business Consulting',
            paragraph: 'Solutions to unique challenges faced by our Pharma, Biotech, or MedTech client partners ensure timely and strategic insights driving short- and long-term success',
            button: '/consulting',
            color : 'bg-[#000]',
            hoverImg: ''
        } 
    },
    {   
        id: 2, src: 'img/consulting/jpg/ci-tracking/market-research.svg', 
        description: {
            heading: 'Market Research',
            paragraph: 'Be it standard or ad-hoc research requirements, DelveInsight\'s effective and robust methodology ensures a detailed understanding of the market and business landscape',
            button: '/market-research',
            color : 'bg-[#000]',
            hoverImg: ''
        } 
    },
    {   
        id: 3, src: 'img/consulting/jpg/ci-tracking/competitive-intelligence.svg', 
        description: {
            heading: 'Competitive Intelligence',
            paragraph: 'DelveInsight\'s competitive intelligence services help organizations identify emerging trends, predict competitor behavior, and uncover growth opportunities.',
            button: '/consulting/competitive-intelligence-services',
            
        } 
    },
    {   
        id: 4, src: 'img/consulting/jpg/ci-tracking/primary-research.svg', 
        description: {
            heading: 'Primary Research',
            paragraph: 'Real-time insights provide first mover advantage, and through DelveInsight’s Primary Research services, ensuring a competitive edge has never been easier.',
            button:'/consulting/primary-research-services'
        } 
    },
    {   
        id: 5, src: 'img/consulting/jpg/ci-tracking/conference-coverage.svg', 
        description: {
            heading: 'Conference Coverage',
            paragraph: 'Utilize the expert coverage and analytical capabilities of DelveInsight\'s subject matter experts across therapy areas to keep well-informed of all recent updates and milestones.',
            button: '/consulting/conference-coverage-services'
        } 
    },
    {   
        id: 6, src: 'img/consulting/jpg/ci-tracking/medical-device-research.svg', 
        description: {
            heading: 'Medical Device Research',
            paragraph: 'Leverage DelveInsight’s experience and knowledge of medical devices through its numerous services around market sizing, competitive landscape analysis, market trends and opportunity assessment.',
            button: '/medical-devices'
        } 
    },
    {   
        id: 7, src: 'img/consulting/jpg/ci-tracking/market-assessment.svg', 
        description: {
            heading: 'Market Assessment',
            paragraph: 'DelveInsight\'s market analysis is a pivotal service in providing accurate market and competitor landscape, and in benchmarking products to better direct decisions in a particular landscape.',
            button:'/consulting/market-assessment-services'
        } 
    },
    {   
        id: 8, src: 'img/consulting/jpg/ci-tracking/business-development-licensing-01.svg', 
        description: {
            heading: 'Business Development & Licensing',
            paragraph: 'Utilize DelveInsight\'s vast service portfolio management services around licensing, partnering, collaboration assessment, as well as due diligence services to ensure the correct partner fit for your specific needs.',
            button:'/consulting/business-development-services'
        } 
    }
  ];
  const hoveredImages = [
    'img/consulting/jpg/ci-tracking/business-consulting-white.svg',
    'img/consulting/jpg/ci-tracking/market-research-white.svg',
    'img/consulting/jpg/ci-tracking/competitive-intelligence-white.svg',
    'img/consulting/jpg/ci-tracking/primary-research-white.svg',
    'img/consulting/jpg/ci-tracking/conference-coverage-white.svg',
    'img/consulting/jpg/ci-tracking/medical-device-research-white.svg',
    'img/consulting/jpg/ci-tracking/market-assessment-white.svg',
    'img/consulting/jpg/ci-tracking/business-development-licensing-white-01.svg',
    
  ];


  const [hoveredIndex, setHoveredIndex] = useState(0);

  const handleImageHover = (index) => {
    // Only update the state if the new index is different
    if (index !== hoveredIndex) {
      setHoveredIndex(index);
    }
  };

  return (
    <div className='w-11/12 xl:max-w-screen max-w-screen-2xl mx-auto my-4 lg:my-8 hidden md:block'>
      {(title) && (
        <SectionHeading title={title} customClass="text-center" style={{ marginBottom: '0' }} />
      )}
      <div className="flex justify-center items-center lg:h-[80vh] mb-[9rem]">
        {/* <div className='absolute border-[1px] border-[#f4f5f8] rounded-full w-[700px] h-[700px]'> */}
          {/* <div className='relative border-[1px] border-[#f4f5f8] rounded-full w-[600px] h-[600px] m-auto top-[3rem]'> */}
            <div className="relative border-[1px] border-[#e1e1e1] rounded-full w-[500px] h-[500px] m-auto top-[3rem]">
              {images.map((image, index) => {
                const angle = (index / images.length) * 360;

                return (
                  <div
                    key={image.id}
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      width: '70px',
                      height: '70px',
                      transform: `translate(-50%, -50%) rotate(${angle}deg) translate(250px) rotate(-${angle}deg)`,
                      zIndex: '2',
                    }}
                    onMouseEnter={() => handleImageHover(index)}
                    onMouseLeave={() => handleImageHover(index)}
                  >
                    <div
                      className={`w-full h-full rounded-full cursor-pointer ${
                        hoveredIndex === index ? 'bg-[#1b5df3]' : 'bg-white'
                      }`} 
                      style={{boxShadow: "0px 11px 13px 0 rgba(31, 136, 104, 0.4)" }}
                    >
                      <Image 
                        priority={true} 
                        src={hoveredIndex === index ? process.env.IMG_CDN+hoveredImages[index] : process.env.IMG_CDN+image.src} 
                        alt={`Image ${image.id}`} 
                        width={60} 
                        height={60} 
                        style={{padding: "0.65rem 0.05rem 0.05rem 0.65rem" }} 
                      />
                    </div>
                  </div>
                );
              })}
              <div className="absolute inset-0 flex flex-col items-center justify-center px-14 text-center">
                <h3 className="text-[#1877F2] text-xl font-semibold">
                  <Link href={process.env.APP_URL+images[hoveredIndex].description.button}>
                    {images[hoveredIndex].description.heading}
                  </Link>
                </h3>
                <p className="text-black">{images[hoveredIndex].description.paragraph}</p>
                <Link href={process.env.APP_URL+images[hoveredIndex].description.button}>
                  <button className='btn btn-primary'>Know More</button>
                </Link>
              </div>
            </div>
          {/* </div> */}
        {/* </div> */}
      </div>
    </div>
  );
};

export default OvalComponent;




